export class StorageGatewayDetails {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "vpcEndpointServiceName",
            "baseName": "vpcEndpointServiceName",
            "type": "string",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "StorageGatewayStatus",
            "format": ""
        },
        {
            "name": "certificate",
            "baseName": "certificate",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return StorageGatewayDetails.attributeTypeMap;
    }
    constructor() {
    }
}
